<template>
  <special-requests-grid
    :value="value"
    :is-edit="!disabled"
    :customer-id="customerId"
    :lob="job.lob"
    :job="job"
    @input="onInput"
  />
</template>

<script>
import specialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'

export default {
  name: 'SeBasicSpecialRequestsGrid',
  components: {
    specialRequestsGrid
  },
  props: {
    value: { type: String, default: () => '' },
    job: { type: Object, default: () => {} },
    customerId: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>
